import { ProdutoModel } from "./produto.model";

export class ProdutoFamiliaModel {
    codigo: number;
    nome: string;
    bytes?: string;
}

export class ProdutoFamiliaRequest {
    public nome: string;
}

export class ProdutoFamiliaCheckboxViewModel {
    public codigo: number = 0;
    public nome: string = '';
    public check: boolean = false;
}

export class ProdutoCategoriaModel {
    codigo: number;
    nome: string;

    produtos: ProdutoModel[];
}